import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot, UrlTree } from '@angular/router';
import { GroupValidationBloc } from '@kp/auth/group-validation.bloc';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class EligibilityTypeRoutingGuard {
  constructor(private _groupValidationBloc: GroupValidationBloc, private _router: Router) {}

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean | UrlTree> {
    const workbookRequested = route.queryParamMap.get('workbookRequested');
    return this._groupValidationBloc.groupValidationDataStatus$.pipe(
      map((groupValidationStatus) => {
        if (groupValidationStatus?.data?.eligibilityVerificationTypes) {
          return groupValidationStatus.data?.eligibilityVerificationTypes?.length === 1
            ? this._router.parseUrl(
                `/welcome/eligibility/${groupValidationStatus.data?.eligibilityVerificationTypes?.[0]}?workbookRequested=${workbookRequested}`
              )
            : true;
        } else {
          return this._router.parseUrl('/welcome/error');
        }
      })
    );
  }
}
